import { useTranslation } from "react-i18next";

export default function Title() {
    const { t } = useTranslation();

    return (
        <>
            <h2 className="text-center w-full font-semibold uppercase">
                {t("navBarItems.toolsMenu.title")}
            </h2>
            <hr className="w-full" />
        </>
    )
}